import { render, staticRenderFns } from "./newTrade.vue?vue&type=template&id=17a05593&"
import script from "./newTrade.vue?vue&type=script&lang=js&"
export * from "./newTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports